import React from 'react';
import styled, { keyframes } from 'styled-components';
import PerformanceAnalyticsCard from './components/PerformanceAnalyticsCard';

interface CourseNoticeCardProps {
  title: string;
  content: string;
  timestamp?: string;
}

const CourseNoticeCard: React.FC<CourseNoticeCardProps> = ({ title, content, timestamp = 'just now' }) => {
  return (
    <StyledWrapper>
      <div className="card">
        <div className="infoBox">
        <div className="img course-icon" />
        <div className="textBox">
          <div className="textContent">
            <p className="h1">{title}</p>
            <span className="span">{timestamp}</span>
          </div>
          <p className="p">{content}</p>
        </div>
        </div>
        <div className="pBox">
          <PerformanceAnalyticsCard />
        </div>
      </div>
    </StyledWrapper>
  );
};

const popInFromCenter = keyframes`
  0% {
    transform: scale(0.3) rotate(-10deg);
    opacity: 0;
  }
  50% {
    transform: scale(1.05) rotate(2deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
`;

const StyledWrapper = styled.div`
  .card {
    width: 100%;
    min-height: 85px;
    background: linear-gradient(135deg, #FF9800, #F57C00);
    border-radius: 20px;
    
    backdrop-filter: blur(10px);
    transition: 0.3s ease-in-out;
    animation: ${popInFromCenter} 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.2);
    position: relative;
    overflow: hidden;
  }
.infoBox{
  margin:10px 0;
  display: flex;
align-items: center;
    justify-content: left;
}
  .card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  .card:hover::before {
    left: 100%;
  }

  .card:hover {
    cursor: pointer;
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 8px 25px rgba(255, 152, 0, 0.4);
  }

  .img {
    width: 55px;
    height: 55px;
    margin-left: 15px;
    border-radius: 15px;
    transition: 0.3s ease-in-out;
  }

  .course-icon {
    background: linear-gradient(135deg, #FFB74D, #FF9800);
    position: relative;
  }

  .course-icon::after {
    content: '📚';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
  }

  .textBox {
    width: calc(100% - 100px);
    margin-left: 15px;
    color: white;
    font-family: 'Poppins', sans-serif;
  }

  .textContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .span {
    font-size: 11px;
    opacity: 0.8;
    background: rgba(255, 255, 255, 0.2);
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 500;
  }

  .h1 {
    font-size: 17px;
    font-weight: 600;
    margin: 0;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .p {
    font-size: 13px;
    font-weight: 400;
    margin: 0;
    opacity: 0.95;
    line-height: 1.4;
  }
    .pBox{
    margin:10px 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
`;

export default CourseNoticeCard;